var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTesty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "url(#paint0_radial_5_278)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9C9.10457 9 10 8.10457 10 7C10 5.89543 9.10457 5 8 5C6.89543 5 6 5.89543 6 7C6 8.10457 6.89543 9 8 9Z",
    fill: "url(#paint1_linear_5_278)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9Z",
    fill: "url(#paint2_linear_5_278)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0006 11.0156C7.82203 11.0156 5.74324 11.4078 6.03045 13.0147C6.42424 15.2834 8.49992 17.0125 11.0006 17.0125C13.4973 17.0125 15.5704 15.2888 15.9737 13.0256C16.26 11.419 14.1792 11.0156 11.0006 11.0156Z",
    fill: "url(#paint3_linear_5_278)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9961 11.0887C12.9513 11.5994 12.5224 12 12 12H10C9.47714 12 9.048 11.5987 9.00376 11.0873C9.60146 11.0362 10.2722 11.0156 11.0006 11.0156C11.7284 11.0156 12.3987 11.0368 12.9961 11.0887Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5774 14.2372C14.7758 15.8761 13.0279 17.0125 11.0006 17.0125C8.97256 17.0125 7.22404 15.8752 6.42548 14.2352C6.99549 13.8434 7.6802 13.5396 8.47959 13.3238C9.27898 13.1079 10.1191 13 11 13C11.8817 13 12.7225 13.1081 13.5224 13.3243C14.3224 13.5405 15.0074 13.8448 15.5774 14.2372Z",
    fill: "url(#paint4_linear_5_278)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5_278",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.32214 6.0491) rotate(53.2971) scale(17.1501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457142,
    stopColor: "#FFD500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_278",
    x1: 9.26466,
    y1: 8.23704,
    x2: 9.26466,
    y2: 6.66204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_278",
    x1: 15.4485,
    y1: 8.42778,
    x2: 15.4485,
    y2: 7.24653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_278",
    x1: 11.002,
    y1: 11.0156,
    x2: 11.002,
    y2: 17.0125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA4426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC632D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_278",
    x1: 11.0014,
    y1: 13,
    x2: 11.0014,
    y2: 15.6538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA200"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesty);
export default __webpack_public_path__ + "static/media/testy.85ee9dc9631d8dd6dfbff3957dd2c7c4.svg";
export { ForwardRef as ReactComponent };